<div class="row">

  <div class="col-md-6">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Locais Cadastrados</h3><br />
        <span class="text-muted">Selecione para editar</span>
        <div class="divider"></div>
      </div>

      <div class="box-body">

        <div class="form-row mb-2">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <div class="position-relative form-group">
              <label for="">Grupo local</label>

              <div [formGroup]="form">
                <select for="" class="form-control" formControlName="grupoLocalNivel1Id" (change)="getCadastrados()">
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.niveis1" [value]="t.id">{{ t.nome }}</option>
                </select>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('grupoLocalNivel1Id').hasError('hasGrupoLocalNivelNaoInformado')">Selecione um
                    nível</small>
                </section>
              </div>

            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="box-table" style="height: 370px; border: 1px solid #ddd; ">
          <table>
            <thead>
              <tr>
                <th class="text-center"><i *ngIf="this.isLoading"
                    class="fa fa-spinner fa-spin fa-fw pull-left"></i>Descrição do local</th>
                <th class="text-center" *ngIf="this.form.get('tipoLocal').value == 2">Código</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center">{{ c.nome }}</td>
                <td class="text-center">{{ c.codigo }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <section *ngIf="this.cadastrados?.length > 0">
          <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
        </section>
        <section *ngIf="this.cadastrados?.length == 0">
          <span class="pl-1"><b>Nenhum resultado</b> </span>
        </section>
      </div>
    </div>
  </div>




  <div class="col-md-6">

    <div class="box bord" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-body" style="height: 615px;">


        <form novalidate class="pt-30" [formGroup]="form" id="form" (validSubmit)="submit()">


          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Descrição do local</label>
                <input class="form-control" formControlName="nome" type="text" maxlength="90" required>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('nome').hasError('isNotUniqueNomeLocal')">Este nome de Local já esta em
                    uso</small>
                </section>
              </div>
            </div>
          </div>


          <section *ngIf="this.form.get('tipoLocal').value == 2" class="animated fadeInDown">

            <div class="row">

              <div class="col-md-12">
                <div class="form-group">
                  <label for="">Código</label>
                  <div class="input-group">
                    <input class="form-control" formControlName="codigo" type="text" maxlength="10">

                    <div class="input-group-append cp" (click)="getNextCodigo()" title="Obter próximo código material">
                      <span class="input-group-text">
                        <i class="fa fa-refresh txt-blue" aria-hidden="true"></i>
                        <span class="pl-2">
                          Cód. automático
                        </span>
                      </span>
                    </div>

                    <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                      <small *ngIf="form.get('codigo').hasError('hasNoValueCodigo')">O Código deve ser informado</small>
                      <small *ngIf="form.get('codigo').hasError('isNotUniqueCodigoSubstacao')">Este código já esta em
                        uso</small>
                    </section>
                  </div>

                </div>
              </div>
            </div>
          </section>


        </form>
      </div>
      <div class="text-center h30">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" title="Exluir Local selecionado"
                (click)="questionDelete(this.form.get('id').value)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="resetParcial()">Limpar</button>

              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>